// extracted by mini-css-extract-plugin
export default {"moreInfoBtn":"isni-result-item_moreInfoBtn__-Q74X","partyImage":"isni-result-item_partyImage__prQLQ"};